import React, { useRef, useEffect } from 'react';
import { Modal } from 'antd';

const PaymentModal = ({ visible, onClose, checkoutUrl, navigate,handleConfirm }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const handleMessage = (event) => {

        console.log("CHALALALALA");
        
      // Optional: verify it’s from your domain
    //   if (!event.origin.includes(process.env.REACT_APP_API_URL == 'https://dev.myginne.com/' ? "devstore.myginne.com" : 'store.myginne.com')) return;
        console.log("event.data?.type=========>",event.data?.type);

      if (event.data?.type === "PAYMENT_SUCCESS") {
        handleConfirm()
      }
      if (event.data?.type === "PAYMENT_FAILED") {
          handleConfirm()
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [navigate, onClose]);

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={null}
      width="80%"
      bodyStyle={{ height: '80vh', padding: 0 }}
      centered
    >
      {checkoutUrl ? (
        <iframe
          ref={iframeRef}
          src={checkoutUrl}
          title="PayMob Checkout"
          width="100%"
          height="100%"
          style={{ border: 'none', borderRadius: '12px' }}
        />
      ) : (
        <div className="flex justify-center items-center h-full text-gray-500">
          Loading Payment Page...
        </div>
      )}
    </Modal>
  );
};

export default PaymentModal;
